import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Input, Select, Checkbox, Button } from 'antd';
import { toast } from 'react-toastify';
import apiRequest from '../../hooks/ApiRequest';


const { Option } = Select;

const AddEditClaimFormField = ({ form, fieldId, modalVisible, onSuccess, claimFormId, onCancel }) => {
  const { getFieldDecorator, setFieldsValue, resetFields } = form;
  const [loading, setLoading] = useState(false);
  const [FieldTypes, setFieldTypes] = useState([]);

  const insurerId = localStorage.getItem('insurerId')
    ? parseInt(localStorage.getItem('insurerId'), 10)
    : null;

  // Correct field names matching API response keys
  const fetchFieldById = async (id) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/field/${id}`,
        'GET'
      );
      if (res.data) {
        setFieldsValue({
          name: res.data?.name,
          fieldKey: res.data?.fieldKey,
          type: res.data?.type,
          claimFormId: claimFormId,
          isRequired: res.data?.isRequired,
          isEmail: res.data?.isEmail,
          isPhoneNumber: res.data?.isPhoneNumber,
        });
      } else {
        toast.error('Failed to fetch field details');
      }
    } catch (err) {
      toast.error('Error loading field details');
    }
  };

  const fetchFieldTypes = async () => {
    // debugger;
    setLoading(true)
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/fieldtypes`,
        'GET',
      )
      // debugger;
      if (response.success) {
        console.log('Field Types Response:', response);
        setFieldTypes(response.data)
        console.log('Confirm Response Set', FieldTypes);
      } else {
        // toast.error(response.message || 'Failed to fetch claim limits')
      }
    } catch (error) {
      toast.error('Error fetching Field Types')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (fieldId) {
      // debugger;
      fetchFieldById(fieldId);
      fetchFieldTypes();
    } else {
      resetFields();
      fetchFieldTypes();
    }
  }, [fieldId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;

      setLoading(true);

      const payload = {
        id: fieldId || 0,
        name: values.name,
        fieldKey: values.fieldKey?.replace(/\s+/g, '').trim(), // ✅ remove all spaces
        type: values.type,
        claimFormId: claimFormId,
        isRequired: values.isRequired || false,
        isEmail: values.isEmail || false,
        isPhoneNumber: values.isPhoneNumber || false,
         insurerId: insurerId,
      };

      const url = fieldId
        ? `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/update/field`
        : `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/add/field`;

      try {
        const res = await apiRequest(url, 'POST', payload);
        if (res?.id || res?.success) {
          toast.success(fieldId ? 'Field updated successfully' : 'Field added successfully');
          onSuccess && onSuccess();
        } else {
          toast.error(res.message || 'Something went wrong');
        }
      } catch (err) {
        toast.error('Request failed');
      } finally {
        setLoading(false);
      }
    });
  };

  return (
    <Form layout="vertical" onSubmit={handleSubmit}>
      <Row gutter={16}>
        <Col md={12}>
          <Form.Item label="Name">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Please enter name' }],
            })(<Input placeholder="Enter name" />)}
          </Form.Item>
        </Col>

        <Col md={12}>
          <Form.Item label="Field Key">
            {getFieldDecorator('fieldKey', {
              rules: [{ required: true, message: 'Please enter field key' }],
            })(<Input placeholder="Enter field key" />)}
          </Form.Item>
        </Col>

        <Col md={12}>
          <Form.Item label="Type">
            {getFieldDecorator('type', {
              rules: [
                {
                  required: true,
                  message: 'Please select a type',
                },
              ],
            })(
              <Select placeholder="Select field type">
                {FieldTypes.map(person => (
                  <Option key={person.name} value={person.name}>
                    {person.name} 
                  </Option>
                ))}
              </Select>,
            )}
          </Form.Item>
         
        </Col>



        <Col span={24}>
          <Form.Item label="Options">
            <Row gutter={16}>
              <Col md={8}>
                {getFieldDecorator('isRequired', { valuePropName: 'checked' })(
                  <Checkbox>Required</Checkbox>
                )}
              </Col>
              <Col md={8}>
                {getFieldDecorator('isEmail', { valuePropName: 'checked' })(
                  <Checkbox>Is Email</Checkbox>
                )}
              </Col>
              <Col md={8}>
                {getFieldDecorator('isPhoneNumber', { valuePropName: 'checked' })(
                  <Checkbox>Is Phone Number</Checkbox>
                )}
              </Col>
            </Row>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {fieldId ? 'Update Field' : 'Add Field'}
        </Button>

        {fieldId && (
          <Button
            type="default"
            danger
            onClick={() => {
              if (onCancel) onCancel();
            }}
            style={{
              marginLeft: 8,
              fontWeight: '500',
              borderRadius: '6px',
              borderColor: '#ff4d4f',
              color: '#ff4d4f',
            }}
          >
            Cancel Edit
          </Button>
        )}
      </Form.Item>
    </Form>
  );
};

export default Form.create({ name: 'claim_form_field_form' })(AddEditClaimFormField);
